<template>
  <v-menu
    v-model="menuContainer"
    :class="{ 'v-menu__activator--disabled': !isSuccess }"
    :close-on-content-click="false"
    :open-on-click="false"
    offset-y
  >
    <v-btn
      slot="activator"
      :disabled="!isSuccess"
      flat
      @click="toggleDropdown"
    >
      <span class="toolbar__button-label">
        <span v-if="category" class="autocomplete__text autocomplete__text--active">{{ category }}</span>
        <span v-else class="autocomplete__text">{{ $t('Common.by') }} {{ $t('Common.category') }}</span>
      </span>
      <v-icon right small v-if="!isSelected">keyboard_arrow_down</v-icon>
      <v-icon right small color="accent" v-if="isSelected" id="menu-item__clear" @click="toggleDropdown">close</v-icon>
    </v-btn>

    <v-list class="v-list--custom">
      <v-list-tile
        v-for="category in ridesCategoriesList"
        :key="category.value"
        @click="getSelectedCategory(category)"
      >
        <v-list-tile-title>{{ category.text }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        v-for="category in b2cCategories"
        :key="category.value"
        @click="getSelectedCategory(category)"
      >
        <v-list-tile-title>{{ category.text }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'MenuItemCategories',
  props: {
    filters: Object,
    type: String,
    status: {
      type: Number,
      default: STATUS_SUCCESS
    }
  },
  data () {
    return {
      menuContainer: false,
      category: null,
      /* todo: ridesCategoriesList */
      isSelected: false
    }
  },
  computed: {
    ridesCategoriesList () {
      return this.$store.state.commonConfig.categories
    },
    b2cCategories () {
      return this.$store.state.commonConfig.b2cCategories
    },
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  methods: {
    resetProps () {
      this.updateFilters()
      this.menuContainer = false
      this.isSelected = false
      this.category = null
    },

    toggleDropdown ($event) {
      if ($event.target.id === 'menu-item__clear') {
        this.resetProps()
        return
      }
      this.menuContainer = true
    },

    updateFilters (category = null) {
      this.$emit('change', { category })
    },

    getSelectedCategory ({ value, text }) {
      this.updateFilters(value)
      this.menuContainer = false
      this.isSelected = true
      this.category = text
    }
  }
}
</script>
